import { atom } from 'recoil'

export const logoEmpresaState = atom({
  key: 'logoEmpresaState',
  default: require('../../../../assets/logo-white.svg')
})
